import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import ReactHtmlParser from "html-react-parser";
import offerlettervalidate from "./offerlettervalidate";
import { API_URL } from "../../../../constants";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useParams, useNavigate } from "react-router-dom";
import { FaSpinner } from "react-icons/fa";
import Select from "react-select";
import { format } from "date-fns";
import CustomDatePicker from "../../../../components/Custom-Datepicker-Dynamic-Input";
import {
  GetServiceCaller,
  PostServiceCaller,
  PostFormServiceCaller,
} from "../../../../services/serviceCaller";
import moment from "moment";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";

const SendOfferLetter = () => {
  const [isDisabled, setIsDisabled] = useState(true);
  const navigate = useNavigate();
  const [submitted, setSubmit] = useState(false);
  const { candidate_id, job_description_id } = useParams();
  const [typeOptions, setTypeOptions] = useState([]);
  const [selectedValue, setSelectedValue] = useState("");
  const [fetchedData, setFetchedData] = useState(null);
  const [buttonsDisabled, setButtonsDisabled] = useState(true);
  const [responseMessage, setResponseMessage] = useState("");
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const [FullName, setFullName] = useState("");
  const [FirstName, setFirstName] = useState("");
  const [Title, setJobTitle] = useState("");
  const [showGross, setShowGross] = useState(false);
  const [selectedMediclaimValue, setSelectedMediclaimValue] = useState("");
  const [selectedOpt, setSelectedOpt] = useState([]);
  const [selectMediclaim, setSelectMediclaim] = useState([]);
  const [mediclaimValue, setMediclaimValue] = useState(0);

  useEffect(() => {
    fetchData(candidate_id);
    fetchInterviewMode();
  }, []);

  const fetchData = async (id) => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}sendofferletterlist/${candidate_id}`
      );
      if (response.status === 200) {
        setIsDisabled(false);
        const { FirstName, FullName } = response?.data?.candidate || {};
        const { Title } = response?.data?.candidateJobId || {};
        setJobTitle(Title);
        setFirstName(FirstName);
        setFullName(FullName);

        setFormData((prevData) => ({
          ...prevData,
          FirstName,
          FullName,
          // Title,
          "#emailCandidateFullName#": FullName,
          "#emailCandidateFirstName#": FirstName,
          "#emailJobTitle#": response.data.candidateJobId,
          Title: response.data.candidateJobId,
          "#emailOfferDate#": moment().format("DD-MMM-YYYY"),
          "#emailOfferLetterExpiredDate#": moment()
            .add(7, "days")
            .format("DD-MMM-YYYY"),
          "#emailABP#": 100
        }));
        setFetchedData(response.data);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("Error fetching course details:", error);
    }
  };

  const fetchInterviewMode = async () => {
    try {
      const response = await GetServiceCaller(
        `${API_URL}sendofferletterlist?TemplateID=`
      );
      const headers = response?.data?.headers;
      const options = [{ value: headers[0].VALUE, label: headers[0].TEXT }];
      setTypeOptions(options);
      const mediclaim = response?.data?.mediclaim;
      const options1 = mediclaim.map((medi) => ({
        value: medi.value,
        // label: getMeditextLabel(medi.text),
        label: medi.text,
      }));
      setSelectMediclaim(options1);
    } catch (error) {
      console.error("Error fetching Type options:", error);
    }
  };

  useEffect(() => {
    if (selectedValue === "8") {
      fetchInterviewMode(selectedValue);
    }
  }, [selectedValue]);

  const handleChange = async (event) => {
    const selectedValue = event.target.value;
    setSelectedValue(selectedValue);
    setShowGross(true);
    setButtonsDisabled(true);

    try {
      const response = await GetServiceCaller(
        `${API_URL}sendofferletterlist?TemplateID=${selectedValue}`
      );
      const data = response.data.tempfield;
      setFetchedData(data);
      setButtonsDisabled(false);
    } catch (error) {
      console.error("Error fetching data from API:", error);
    }
  };
  const handleChanged = async (event, key) => {
    console.log("event, key", event, key);

    const { value } = event.target;

    setFormData((prevData) => ({
      ...prevData,
      [key]: value,
    }));

    const error = await offerlettervalidate(key, value, formData);
    setErrors((prevErrors) => ({
      ...prevErrors,
      [key]: error.message,
    }));
  };
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Generate Offer Letter"));
  }, []);
  function calculateTotal() {
    var total = 0;
    Object.entries(fetchedData).forEach(([key, value]) => {
      if (
        [
          "#emailbasicAmount#",
          "#emailHRA#",
          "#emailSplAllow#",
          "#emailLTA#",
          "#emailConvAllow#",
          "#emailNPS#",
        ].includes(value)
      ) {
        total += parseFloat(formData[value] || 0);
      }
    });
    return total;
  }

  function calculateCTC() {
    const emailbasicAmount = parseFloat(formData["#emailbasicAmount#"] || 0);
    // const emailHRA = parseFloat(formData['#emailHRA#'] || 0);
    const emailSplAllow = parseFloat(formData["#emailSplAllow#"] || 0);
    const emailLTA= parseFloat(formData["#emailLTA#"] || 0);
    const emailConvAllow = parseFloat(formData["#emailConvAllow#"] || 0);
    const emailGrossSalary = calculateTotal();
    const emailNPS = parseFloat(formData["#emailNPS#"] || 0);
    const emailPFMonthly = parseFloat(formData["#emailPF(Monthly)#"] || 0);
    const emailABP = parseFloat(formData["#emailABP#"] || 0);
    const emailLeaveEncashment = emailbasicAmount * (15 / 30);
    const emailAnnualBasicAmount = emailbasicAmount * 12;
    // const emailAnnualBasicHRA = emailHRA * 12;
    const emailAnnualSplAllow = emailSplAllow * 12;
    const emailAnnualConvAllow = emailConvAllow * 12;
    const emailAnnualGrossSalary = emailGrossSalary * 12;    
    const emailAnnualEPF = emailPFMonthly * 12;
    const emailAnnualGratuity = Math.round(
      emailAnnualBasicAmount * (4.8 / 100)
    );
    const emailMediclaimInsurance = parseFloat(
      formData["emailMediclaimInsurance"] || 0
    );

    const emailMediclaimInsuranceText = parseFloat(
      formData["emailMediclaimInsuranceText"] || 0
    );
    const emailAnnualPerformanceBonus = (emailGrossSalary * emailABP) / 100;
    const emailAnnualCTC = Math.round(
      emailAnnualGrossSalary +
        emailAnnualEPF +
        emailLeaveEncashment +
        emailAnnualPerformanceBonus +
        emailAnnualGratuity +
        emailMediclaimInsuranceText  
    );

    return Number(emailAnnualCTC).toFixed(2);
  }
  const handleDropDownChange = async (selected) => {
    setSelectedOpt([selected]); // Updated to set an array with the selected option

    const updatedFormData = {
      ...formData,
      emailMediclaimInsurance: selected.value,
      emailMediclaimInsuranceText: getMediLabelByText(selected.label),
    };

    setFormData(updatedFormData);

    const error = await offerlettervalidate(
      "emailMediclaimInsurance",
      selected.value,
      updatedFormData
    );
    setErrors((prevErrors) => ({
      ...prevErrors,
      emailMediclaimInsurance: error.message,
    }));
  };

  const fieldLabels = {
    "#emailOfferDate#": "Offer Date",
    "#emailAadharAddress#": "Permanant Address",
    "#emailJoiningLocation#": "Joining Location",
    "#emailJoiningDate#": "Joining Date",
    "#emailOfferLetterExpiredDate#": "Offer Letter Expiry Date",
    "#emailbasicAmount#": "Basic Amount",
    "#emailHRA#": "HRA",
    "#emailSplAllow#": "Professional Development Allowance",
    "#emailLTA#": "Leave Travel Allowance",
    "#emailConvAllow#": "Conveyance Allowance",
    "#emailNPS#": "NPS",
    "#emailPF(Monthly)#": "PF",
    emailMediclaimInsurance: "Mediclaim Insurance",
    "#emailCandidateFullName#": "Full Name",
    "#emailCandidateFirstName#": "First Name",
    "#emailJobTitle#": "Job Title",
  };

  const handlePreview = async (event) => {
    event.preventDefault();

    const mandatoryFields = [
      "#emailOfferDate#",
      "#emailAadharAddress#",
      "#emailJoiningLocation#",
      "#emailJoiningDate#",
      "#emailOfferLetterExpiredDate#",
      "#emailbasicAmount#",
      "#emailHRA#",
      "#emailSplAllow#",
      "#emailLTA#",
      "#emailConvAllow#",
      "#emailNPS#",
      "#emailPF(Monthly)#",
      "emailMediclaimInsurance",
      "#emailCandidateFullName#",
      "#emailCandidateFirstName#",
      "#emailJobTitle#",
    ];

    let isFormInvalid = false;
    const updatedErrors = {};
    for (const field of mandatoryFields) {
      const fieldValue = formData[field];

      if (!fieldValue) {
        updatedErrors[field] = `${fieldLabels[field]} is required`;
        isFormInvalid = true;
      } else {
        const error = await offerlettervalidate(field, fieldValue, formData);
        updatedErrors[field] = error.message;

        if (error.status) {
          isFormInvalid = true;
        }
      }
    }
    setErrors(updatedErrors);
    if (!isFormInvalid) {
      const interviewMode = selectedValue;
      const { offerLetterExpiryDate, ...formDataExpiryDate } = formData;

      formDataExpiryDate["#emailMediclaimInsurance#"] =
        formData.emailMediclaimInsurance;
      formDataExpiryDate["#emailMediclaimInsuranceText#"] = getMediLabelByText(
        formData.emailMediclaimInsuranceText
      );

      const updatedFormData = {
        ...formDataExpiryDate,
        "#emailinterviewMode#": interviewMode,
        "#emailIncentive#": 0,
        "#emailofferLetterExpiryDate#": formData.offerLetterExpiryDate,
        // "#emailCandidateFullName#": formData.FullName,  // To make editable 07-07-25
        "#emailCandidateFirstName#": formData.FirstName,
        "#emailMediclaimInsuranceText#": formData.emailMediclaimInsuranceText,
      };

      try {
        const response = await PostServiceCaller(
          `${API_URL}preview-template`,
          updatedFormData,
          "post"
        );
        setResponseMessage(response.data.data);
        setErrors({});
      } catch (error) {
        console.error("Error posting form data:", error);
        setResponseMessage(`Error posting form data: ${error.message}`);
      }
    } else {
      setErrors(updatedErrors);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const mandatoryFields = [
      "#emailOfferDate#",
      "#emailAadharAddress#",
      "#emailJoiningLocation#",
      "#emailJoiningDate#",
      "#emailOfferLetterExpiredDate#",
      "#emailbasicAmount#",
      "#emailHRA#",
      "#emailSplAllow#",
      "#emailLTA#",
      "#emailConvAllow#",
      "#emailNPS#",
      "#emailPF(Monthly)#",
      "emailMediclaimInsurance",
      "#emailCandidateFullName#",
      "#emailCandidateFirstName#",
      "#emailJobTitle#",

      //  '#emailIncentive#'
    ];

    let isFormInvalid = false;
    const updatedErrors = {};

    for (const field of mandatoryFields) {
      const fieldValue = formData[field];

      if (!fieldValue) {
        updatedErrors[field] = `${fieldLabels[field]} is required`;
        isFormInvalid = true;
      } else {
        const error = await offerlettervalidate(field, fieldValue, formData);
        updatedErrors[field] = error.message;

        if (error.status) {
          isFormInvalid = true;
        }
      }
    }
    setErrors(updatedErrors);

    if (!isFormInvalid) {
      const interviewMode = selectedValue;
      const { offerLetterExpiryDate, ...formDataExpiryDate } = formData;

      formDataExpiryDate["#emailMediclaimInsurance#"] = getMediLabelByText(
        formData.emailMediclaimInsuranceText
      );

      const lines = mandatoryFields.map((field) => ({
        candidate_offerletters_id: "",
        CandidateID: candidate_id,
        parameter_name: field.replace(/#/g, ""),
        parameter_value: formData[field],
        CreatedBy: 1,
        ModifiedBy: 1,
        CreatedDate: new Date().toISOString(),
        ModifiedDate: new Date().toISOString(),
        RevisionNumber: 1,
      }));

      const formatDate = (date) => {
        if (!(date instanceof Date && !isNaN(date))) {
          return null;
        }
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}/${month}/${day}`;
      };

      const updatedFormData = {
        ID: "", //to be dynamic
        CandidateID: candidate_id, //to be dynamic
        OfferLetterSenderID: 1221,
        OfferLetterSendDate: formatDate(new Date()),
        OfferLetterExpiryDate: formatDate(new Date()),
        OfferLetterAcceptRejectDate: formatDate(new Date()),
        OfferLetterTemplateID: 8,
        OfferLetterTags: "nice",
        OfferLetterStatus_185: 1000,
        headers: { ...formDataExpiryDate },
        lines: lines,
      };

      try {
        setSubmit(true);
        const response = await PostServiceCaller(
          `${API_URL}sendofferletterlist`,
          updatedFormData,
          "post"
        );
        toast.success("Offer Letter Succesfully Send");

        navigate("/candidate-in-process");
        setErrors({});
        setSubmit(false);
      } catch (error) {
        console.error("Error posting form data:", error);
        toast.error("Sorry Offer Letter Not Created");
      }
    }
  };

  const handleDateChange = (date, name) => {
    if (!date) return; // Prevent setting null values

    setFormData((prevState) => {
      const updatedData = { ...prevState, [name]: date };

      const offerDate = moment(updatedData["#emailOfferDate#"], "DD-MMM-YYYY");
      const expiryDate = moment(
        updatedData["#emailOfferLetterExpiredDate#"],
        "DD-MMM-YYYY"
      );

      if (name === "#emailOfferDate#" && offerDate.isAfter(expiryDate)) {
        toast.error("Offer Date cannot be after the Offer Letter Expiry Date");
        return prevState; // Prevent invalid update
      }

      return updatedData; // Allow update if valid
    });

    // Remove error if the date is valid
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: null,
    }));
  };

  // const handleDateChange = (date, name) => {
  //   console.log(
  //     `Date with a new custom datepicker in offer letter ${date} ${name}`
  //   );
  //   if (date) {
  //     setFormData((prevState) => ({
  //       ...prevState,
  //       [name]: date,
  //     }));
  //   }
  //   setErrors((prevErrors) => {
  //     if (prevErrors[name]) {
  //       return {
  //         ...prevErrors,
  //         [name]: null,
  //       };
  //     }
  //     return prevErrors;
  //   });
  // };
  const customLabels = {
    "#emailOfferDate#": "Offer Date",
    "#emailOfferLetterExpiredDate#": "Offer Letter Expiry Date",
    "#emailCandidateFullName#": "Full Name",
    "#emailAadharAddress#": "Permanant Address",
    "#emailCandidateFirstName#": "First Name",
    "#emailbasicAmount#": "Basic Amount",
    "#emailJobTitle#": "Job Title",
    // '#emailJoiningLocation#': 'Joining Location',
    "#emailJoiningDate#": "Joining Date",
    "#emailHRA#": "HRA",
    "#emailSplAllow#": "Professional Development Allowance",
    "#emailLTA#": "Leave Travel Allowance",
    "#emailConvAllow#": "Conveyance Allowance",
    "#emailNPS#": "NPS",
    "#emailPF(Monthly)#": "PF(Monthly)",
    // '#emailIncentive#': 'Incentive',
  };

  const handleCancel = () => {
    navigate("/candidate-in-process");
  };

  function CurrencyFormat(number) {
    if (number === null || number === undefined) return "";

    const numParts = number.toString().split(".");
    let integerPart = numParts[0];
    const decimalPart = numParts.length > 1 ? "." + numParts[1] : "";

    const lastThreeDigits = integerPart.slice(-3);
    const otherDigits = integerPart.slice(0, -3);

    if (otherDigits !== "") {
      integerPart =
        otherDigits.replace(/\B(?=(\d{2})+(?!\d))/g, ",") +
        "," +
        lastThreeDigits;
    }

    return integerPart + decimalPart;
  }

  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid d-flex flex-column flex-lg-row gap-2 justify-content-evenly">
          <div className="col-md-12 col-lg-5" id="skill-table-area-2">
            <Form onSubmit={handleSubmit}>
              <div className="row">
                <div className="col-sm-6">
                  <Form.Group className="d-flex gap-2 row col-form-label">
                    <div className="">
                      <label className="">
                        <strong>Offer Letter Template</strong>
                        <span className="required">*</span>
                      </label>
                    </div>
                    <div className="col-sm-12">
                      <select
                        className="form-select"
                        aria-label="Default select example"
                        name="JobType"
                        value={selectedValue}
                        onChange={handleChange}
                        disabled={isDisabled}
                      >
                        <option value="">Select</option>
                        {typeOptions.map((option) => (
                          <option key={option.value} value={option.value}>
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </Form.Group>
                </div>
                {fetchedData && (
                  <>
                    {Object.entries(fetchedData).map(([key, value]) => {
                      // Skip rendering if key is 'candidate' or 'candidateJobId'
                      if (
                        key === "candidate" ||
                        key === "candidateJobId" ||
                        key === "56"
                      ) {
                        return null;
                      }

                      const typeMap = {
                        "#emailOfferDate#": "date",
                        "#emailOfferLetterExpiredDate#": "date",
                        "#emailCandidateFullName#": "text",
                        "#emailAadharAddress#": "text",
                        "#emailCandidateFirstName#": "text",
                        "#emailbasicAmount#": "number",
                        "#emailJobTitle#": "text",
                        // '#emailJoiningLocation#': 'text',
                        "#emailJoiningDate#": "date",
                        "#emailHRA#": "number",
                        "#emailSplAllow#": "number",
                        "#emailLTA#": "number",
                        "#emailConvAllow#": "number",
                        "#emailNPS#": "number",
                        "#emailPF(Monthly)#": "number",
                        // '#emailIncentive#': 'number',
                        "#emailMediclaimInsurance#": "number",
                      };

                      const label =
                        customLabels[value] ||
                        (typeof value === "string"
                          ? value
                              .replace(/#|email/g, "")
                              .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) => {
                                return index === 0
                                  ? word.toUpperCase()
                                  : " " + word.toUpperCase();
                              })
                              .replace(/\s+/g, " ")
                          : "");

                      const displayValue =
                        typeof value === "object"
                          ? ""
                          : // : value === "#emailCandidateFullName#"  // To make editable 07-07-25
                          // ? formData.FullName
                          value === "#emailCandidateFirstName#"
                          ? formData.FirstName
                          : // : value === "#emailJobTitle#" // To make editable 07-07-25
                          // ? formData.Title
                          value === "Title"
                          ? formData.Title
                          : formData[value]; //(formData[value] || '').replace(/^\w/, (c) => c.toUpperCase());

                      const type = typeMap[value] || "text";

                      return (
                        <Form.Group key={key} className="mt-2 col-sm-6">
                          <label htmlFor={key} className="form-label">
                            <strong>{label}</strong>
                            <span className="required">*</span>
                          </label>
                          <div className="">
                            {type === "date" ? (
                              <>
                                <CustomDatePicker
                                  isinvalid={errors[value] ? true : false}
                                  name={value}
                                  className={` ${
                                    errors[value] ? "is-invalid" : ""
                                  }`}
                                  handleDateChange={handleDateChange}
                                  value={formData[value]}
                                ></CustomDatePicker>
                                <span className="error">{errors[value]}</span>
                              </>
                            ) : value === "#emailMediclaimInsurance#" ? (
                              <>
                                <Select
                                  name="mediclaim"
                                  value={selectedOpt}
                                  className={` ${
                                    errors["emailMediclaimInsurance"]
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                  onChange={handleDropDownChange}
                                  options={selectMediclaim}
                                />
                                <span className="error">
                                  {errors["emailMediclaimInsurance"]}
                                </span>
                              </>
                            ) : (
                              <>
                                <input
                                  type={type}
                                  className={`form-control ${
                                    type === "number" ? "text-end" : ""
                                  } ${errors[value] ? "is-invalid" : ""}`}
                                  id={key}
                                  name={value}
                                  value={displayValue}
                                  onChange={(e) => handleChanged(e, value)}
                                  onKeyDown={(e) => {
                                    if (
                                      type === "number" &&
                                      (e.key === "ArrowUp" ||
                                        e.key === "ArrowDown")
                                    ) {
                                      e.preventDefault(); // Prevent default arrow key behavior
                                    }
                                  }}
                                  onWheel={(e) => {
                                    if (type === "number") {
                                      e.target.blur(); // Prevent value change on mouse wheel scroll
                                    }
                                  }}
                                />
                                <span className="error">{errors[value]}</span>
                              </>
                            )}
                          </div>
                        </Form.Group>
                      );
                    })}
                    <div className="row p-0 m-0">
                      <div className="col-sm-6">
                        {showGross && (
                          <Form.Group key="gross" className="row">
                            <label htmlFor="gross" className="">
                              <strong>APB (% of Gross)</strong>
                            </label>
                            <div className="">
                              <input
                                type="number"
                                className={`form-control text-end`}
                                id="#emailABP#"
                                name="#emailABP#"
                                value={formData["#emailABP#"] || ""}
                                 onChange={(e) => handleChanged(e, "#emailABP#")}
                              />
                            </div>
                          </Form.Group>
                        )}
                      </div>
                      <div className="col-sm-6">
                        {showGross && (
                          <Form.Group key="gross" className="row">
                            <label htmlFor="gross" className="">
                              <strong>Gross</strong>
                            </label>
                            <div className="">
                              <input
                                type="text"
                                className={`form-control ${"text-end"}`}
                                id="gross"
                                name="gross"
                                value={CurrencyFormat(calculateTotal())}
                                disabled
                              />
                            </div>
                          </Form.Group>
                        )}
                      </div>

                      <div className="ml-2 mt-4 col-sm-6">
                        {showGross && (
                          <Form.Group key="gross" className="row mb-3">
                            <label htmlFor="gross" className="">
                              <strong>CTC</strong>
                            </label>
                            <div className="">
                              <input
                                type="text"
                                className={`form-control ${"text-end"}`}
                                id="CTC"
                                name="CTC"
                                value={CurrencyFormat(calculateCTC())}
                                disabled
                              />
                            </div>
                          </Form.Group>
                        )}
                      </div>
                    </div>
                    <div className="text-end">
                      <button
                        className={`custom-sm-btn ${
                          buttonsDisabled ? "disabled-button" : ""
                        }`}
                        onClick={handlePreview}
                        disabled={buttonsDisabled}
                      >
                        Preview
                      </button>
                    </div>
                  </>
                )}
              </div>
            </Form>

            <div className="row">
              <div className="text-end mt-3">
                <button className="cancel-btn me-1" onClick={handleCancel}>
                  Cancel
                </button>
                <button
                  // disabled={submitted ? true : false}
                  disabled={buttonsDisabled || submitted}
                  onClick={handleSubmit}
                  type=""
                  className={`custom-btn ${
                    buttonsDisabled ? "disabled-button" : ""
                  }`}
                >
                  {submitted ? <FaSpinner class="sm-spinner" /> : "Submit"}
                </button>
              </div>
            </div>
          </div>
          <div
            className="col-md-12 col-lg-7"
            id="skill-table-area-2"
            style={{ maxHeight: "918px", overflowY: "auto" }}
          >
            <h5 className="text-center">
              <strong>
                <u>Preview Offer Letter</u>
              </strong>
            </h5>
            {responseMessage && <div>{ReactHtmlParser(responseMessage)}</div>}
          </div>
        </div>
      </div>
    </>
  );
};

export default SendOfferLetter;

function getMeditextLabel(label) {
  let text = "";
  switch (label) {
    case "5500":
      text = "5,500 (Individual Employee)";
      break;
    case "10000":
      text = "10,000 (Employee + Spouse)";
      break;
    case "15000":
      text = "15,000 (Employee + Spouse + 1 kid)";
      break;
    case "20000":
      text = "20,000 (Employee + Spouse + 2 kids)";
      break;
  }
  return text;
}
function getMediLabelByText(label) {
  let text = "";
  switch (label) {
    case "5,500 (Individual Employee)":
      text = "5500";
      break;
    case "10,000 (Employee + Spouse)":
      text = "10000";
      break;
    case "15,000 (Employee + Spouse + 1 kid)":
      text = "15000";
      break;
    case "20,000 (Employee + Spouse + 2 kids)":
      text = "20000";
      break;
  }
  return text;
}
